// Support.js
// Support / contact page. Public route, reached from the TopBar menu.
// Layout + typography come from the shared LegalDocument component.

import React from "react";
import LegalDocument, { P, Mail, Link } from "../components/LegalDocument";

export default function Support() {
  return (
    <LegalDocument title="Support">
      <P>
        Have a question, found a bug, or want to share feedback? Reach out directly and
        we’ll get back to you as soon as possible.
      </P>
      <P><Mail /></P>
      <P>
        For subscription-related issues, purchases can be managed through your Apple ID account
        settings under Settings → [Your Name] → Subscriptions. Refund requests are handled directly
        by Apple at{" "}
        <Link href="https://reportaproblem.apple.com">reportaproblem.apple.com</Link>.
      </P>
    </LegalDocument>
  );
}
